module.exports = __webpack_public_path__ + "media/light-tour.91e611b4.mp4";